import React from 'react';

export const LogsQueueContext = React.createContext('logsQueue');
export const LogsQueueContextProvider = LogsQueueContext.Provider;
export const LogsQueueContextConsumer = LogsQueueContext.Consumer;

export const RequestsQueueContext = React.createContext('requestsQueue');
export const RequestsQueueContextProvider = RequestsQueueContext.Provider;
export const RequestsQueueContextConsumer = RequestsQueueContext.Consumer;

export const QueuesProvider = ({children, logsQueue, requestsQueue}) => (
  <LogsQueueContextProvider value={logsQueue}>
    <RequestsQueueContextProvider value={requestsQueue}>
      {children}
    </RequestsQueueContextProvider>
  </LogsQueueContextProvider>
);

export const QueuesConsumer = ({children}) => (
  <LogsQueueContextConsumer>
    {logsQueue => (
      <RequestsQueueContextConsumer>
        {requestsQueue => children({logsQueue, requestsQueue})}
      </RequestsQueueContextConsumer>
    )}
  </LogsQueueContextConsumer>
);

export function withQueues(WrappedComponent) {
  return ({...props}) => (
    <QueuesConsumer>
      {({logsQueue, requestsQueue}) => (
        <WrappedComponent
          {...props}
          logsQueue={logsQueue}
          requestsQueue={requestsQueue}
        />
      )}
    </QueuesConsumer>
  );
}
